const announcementContext = require.context(
  "../images/announcements",
  false,
  /\.(png|jpe?g|svg)$/i
);

function filenameFromKey(key) {
  return key.replace(/^\.\//, "").replace(/\.[^.]+$/, "");
}

/** @returns {{ key: string, src: string, label: string }[]} newest first (by filename) */
function getAnnouncementImages() {
  return announcementContext
    .keys()
    .sort()
    .reverse()
    .map((key) => ({
      key,
      src: announcementContext(key),
      label: filenameFromKey(key),
    }));
}

function getLatestAnnouncementImage() {
  const latest = getAnnouncementImages()[0];
  return latest ? latest.src : null;
}

export { getAnnouncementImages, getLatestAnnouncementImage };
